import {createActionWithoutPayload, createActionWithPayload} from "./utils.actions";


export const [pushBack, isPushBackAction] = createActionWithoutPayload('ROUTER_PUSH_BACK')
export const [redirect, isRedirectAction] = createActionWithPayload<string>('REDIRECT')